"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _OloCheckout = _interopRequireDefault(require("../../OloCheckout"));

var MenuCartDisplayTotal = function MenuCartDisplayTotal(_ref) {
  var total = _ref.total,
      onCheckout = _ref.onCheckout,
      cart = _ref.cart,
      locationId = _ref.locationId,
      isOpen = _ref.isOpen,
      _ref$totalTitle = _ref.totalTitle,
      totalTitle = _ref$totalTitle === void 0 ? 'Subtotal' : _ref$totalTitle;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "menu-cart-total"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h4", null, totalTitle), /*#__PURE__*/_react["default"].createElement("h4", null, "$", total.toFixed(2))), /*#__PURE__*/_react["default"].createElement(_OloCheckout["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      primary: true,
      fluid: true,
      onClick: onCheckout,
      disabled: total === 0 || !isOpen
    }, isOpen ? "Checkout" : "Ordering Closed"),
    cart: cart,
    locationId: locationId
  }));
};

var _default = MenuCartDisplayTotal;
exports["default"] = _default;